import { IcebergAlert, IcebergAlertVariant } from '@tradesolution/iceberg-ui-react';

interface Props {
  text?: string;
}

const SuccessFeedback = (props: Props) => {
  if (!props.text) return null;
  return (
    <div className="mt-3">
      <IcebergAlert variant={IcebergAlertVariant.Success} body={props.text} />
    </div>
  );
};

export default SuccessFeedback;
